/* eslint-disable no-alert */
/* eslint-disable react-native/no-inline-styles */
import {useNavigation} from '@react-navigation/native';
import {Button, Icon, Layout, Text} from '@ui-kitten/components';
import moment from 'moment';
import React, {useState} from 'react';
import {Linking, StyleSheet, View} from 'react-native';
import {useSelector} from 'react-redux';
import {AUTHENTICATED_ROUTES} from '../../navigation/constants';
import {getPackageTypeById, px, safeText, useIsLandscape} from '../../utils';
import {renderIf} from '../../utils/Utils';
import Payment from '../Payment';

const PaymentDetail = ({data}) => {
  const [paymentModalParams, setPaymentModalParams] = useState();
  const navigation = useNavigation();
  const isLandscape = useIsLandscape();
  const {
    id,
    packageId,
    paymentType,
    paymentMonth,
    notes,
    paymentStatus,
    date,
    totalPrice,
    isActionRequire,
    invoiceUrl,
  } = data || {};
  const packages = useSelector((state) => state.general.packages);

  const handleOpenLink = async (url) => {
    const supported = await Linking.canOpenURL(url);

    if (supported) {
      await Linking.openURL(url);
    } else {
      alert(`Don't know how to open this URL: ${url}`);
    }
  };

  return (
    <>
      <Layout style={styles.container}>
        <Layout level="3" style={styles.header}>
          <Text style={{fontSize: 16}}>
            {moment(date).format('DD MMM YYYY hh:mm A')}
          </Text>
        </Layout>
        <Layout
          style={[
            styles.body,
            isLandscape ? {flexDirection: 'row'} : undefined,
          ]}>
          <View style={{flex: 1}}>
            <Text style={[styles.text, {fontSize: 16, fontWeight: '600'}]}>
              {`${getPackageTypeById({
                packages,
                id: packageId,
              })}`}
            </Text>
            <Text style={[styles.text, {fontSize: 16, marginTop: 12}]}>
              {'Payment Month : ' + paymentMonth}
            </Text>
            <Text style={[styles.text, {fontSize: 16, marginTop: 12}]}>
              {'Payment Mode : ' + paymentType}
            </Text>
            <Text style={[styles.text, {fontSize: 18, marginTop: 12}]}>
              {'RM ' + safeText(totalPrice)}
            </Text>
            {/* <Text style={[styles.text, {fontSize: 16}]}>
          {getKidNameById({kids, id: kidId})}
        </Text> */}
            {paymentStatus === 'pending' && (
              <Text style={[styles.text, {fontSize: 16, color: '#074EE8'}]}>
                {'Pending verification'}
              </Text>
            )}
            {paymentStatus === 'rejected' && (
              <>
                <Text
                  style={[
                    styles.text,
                    {fontSize: 16, fontWeight: '500', color: '#E30707'},
                  ]}>
                  {'Rejected'}
                </Text>
                <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <Icon
                    name="alert-circle-outline"
                    fill="#E30707"
                    style={{width: 15, height: 15}}
                  />
                  {renderIf(
                    notes,
                    <Text
                      style={{fontSize: 12, color: '#E30707', marginLeft: 6}}>
                      {notes}
                    </Text>,
                  )}
                </View>
              </>
            )}
            {(paymentStatus === 'success' ||
              paymentStatus === 'payment-success') && (
              <Text style={[styles.text, {fontSize: 16, color: '#00AA4E'}]}>
                {'Accepted'}
              </Text>
            )}
            {(paymentStatus === 'failed' ||
              paymentStatus === 'payment-failed') && (
              <Text
                style={[
                  styles.text,
                  {fontSize: 16, fontWeight: '500', color: '#E30707'},
                ]}>
                {'Failed'}
                {renderIf(notes, `: ${notes}`)}
              </Text>
            )}
          </View>
          <View
            style={[
              isLandscape
                ? {justifyContent: 'center', marginRight: 49}
                : {alignItems: 'center'},
            ]}>
            {paymentStatus === 'rejected' && isActionRequire === 1 && (
              <Button
                style={{marginTop: 18, width: isLandscape ? 170 : '100%'}}
                type="primary"
                onPress={() => {
                  const paramsToSet = {
                    transactionId: id,
                    isRenew: true,
                    isResubmit: true,
                    totalPrice,
                  };
                  if (isLandscape) {
                    setPaymentModalParams(paramsToSet);
                  } else {
                    navigation.navigate(
                      AUTHENTICATED_ROUTES.payment.path,
                      paramsToSet,
                    );
                  }
                }}>
                {'Resubmit'}
              </Button>
            )}
            {Boolean(invoiceUrl) &&
              (paymentStatus === 'success' ||
                paymentStatus === 'payment-success') && (
                <Button
                  style={{marginTop: 18, width: isLandscape ? 170 : '100%'}}
                  appearance="outline"
                  onPress={() => handleOpenLink(invoiceUrl)}>
                  {'View Receipt'}
                </Button>
              )}
          </View>
        </Layout>
      </Layout>
      {Boolean(paymentModalParams) && (
        <Payment
          landscapeParams={paymentModalParams}
          onModalBackPressed={() => setPaymentModalParams(undefined)}
          handleCloseModal={() => setPaymentModalParams(undefined)}
        />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: px(28),
  },
  header: {
    paddingHorizontal: px(17),
    paddingVertical: px(7),
  },
  body: {
    marginTop: px(18),
    paddingHorizontal: px(17),
  },
  text: {
    marginTop: px(9),
    color: 'black',
  },
});

export default PaymentDetail;
